// providers/env.ts
declare global {
  interface Window {
    __APP_CONFIG__?: { API_BASE?: string };
  }
}

const runtimeBase =
  window.__APP_CONFIG__?.API_BASE ||
  (process.env.REACT_APP_API_BASE as string) ||
  `${window.location.protocol}//${window.location.host}`;

export const runtimeBasePath: string = runtimeBase;
